import React, { Component } from "react";

import BLButton from "../../../utils/components/BLButton";
import API, { headers } from "../../../utils/API";
import { handleErrors } from "../../../utils/helper";
import { CSSTransition } from "react-transition-group";
import { BLSearchSuggestions } from "../../../utils/components/BLSearchSuggestions";
import BLLoader from "../../../utils/components/BLLoader";
import { global } from "../../../App/routes";
import { withRouter } from "react-router";
import BLAnimatedInput from "../../../utils/components/BLAnimatedInput";

class Search extends Component {
  state = {
    keyword: "",
    suggestions: [],
    isSearching: false,
    showQueryInfo: false,
  };

  searchTimeout = "";

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.keyword !== this.state.keyword) {
      this.handleSuggestions();
    }

    if (this.state.keyword && !prevState.keyword) {
      const buttonEl = document.querySelector(".send-button");

      if (buttonEl) {
        const keyboardEl = document.querySelector(".remove-keyword-button");

        keyboardEl.style.right = `${buttonEl.offsetWidth + 10}px`;
      }
    }
  };

  handleSuggestions = () => {
    clearTimeout(this.searchTimeout);

    if (this.state.keyword !== "") {
      this.setState({ isSearching: true });

      if (this.state.keyword?.length > 2)
        this.setState({ showQueryInfo: false });

      this.searchTimeout = setTimeout(() => {
        if (this.state.keyword.length < 3) {
          this.setState({ showQueryInfo: true, isSearching: false });
          return;
        }

        API.get(
          `search?q=${this.state.keyword}&limit=5&currency=${this.props.currency.code}`,
          { headers: { ...headers, "Accept-Language": this.props.lang } }
        )
          .then((response) => {
            const { data } = response.data;

            this.setState({ suggestions: data, isSearching: false });
          })
          .catch((err) => {
            handleErrors(err);
            this.setState({ isSearching: false });
          });
      }, 1250);
    } else {
      this.setState({
        suggestions: [],
        isSearching: false,
        showQueryInfo: false,
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.state.keyword && this.state.keyword.length > 2)
      this.props.history.push(
        `${global.search.links[this.props.lang]}?filters:keyword=${
          this.state.keyword
        }`
      );
  };

  render() {
    return (
      <div className="search-area-holder">
        <form
          action="#!"
          className="d-flex justify-content-start align-items-center position-relative w-100"
          onSubmit={this.handleSubmit}
        >
          <div className="division search-input-holder d-flex justify-content-start align-items-center">
            <label htmlFor="search-input" className="search-label">
              {this.state.isSearching ? (
                <BLLoader />
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.9587 16.9437L23.7924 22.7761C24.0692 23.0528 24.0692 23.5104 23.7924 23.7871C23.654 23.9308 23.4677 24 23.2868 24C23.1058 24 22.9195 23.9255 22.7811 23.7871L16.9474 17.9548C15.1484 19.5193 12.8011 20.4665 10.2355 20.4665C4.59348 20.4665 0 15.8741 0 10.2333C0 4.59246 4.58816 0 10.2355 0C15.8776 0 20.4711 4.58714 20.4711 10.2333C20.4711 12.7982 19.5236 15.145 17.9587 16.9437ZM10.2302 1.43681C5.38124 1.43681 1.4318 5.38004 1.4318 10.2333C1.4318 15.0865 5.38124 19.035 10.2302 19.035C15.0845 19.035 19.0286 15.0812 19.0286 10.2333C19.0286 5.38537 15.0845 1.43681 10.2302 1.43681Z"
                    fill="#8E8E8E"
                  />
                </svg>
              )}
            </label>
            <BLAnimatedInput
              placeholders={this.props
                .translate("home.banner.search_placeholders")
                .split(",")}
              inputProps={{
                className: "search-input",
                id: "search-input",
                value: this.state.keyword,
                onChange: (e) => this.setState({ keyword: e.target.value }),
                tabIndex: 0,
              }}
            />

            <div
              className="short-characters-info position-absolute"
              data-show={this.state.showQueryInfo}
            >
              <span className="text">
                {this.props.translate("home.banner.short_characters_info")}
              </span>
            </div>
          </div>
          <div className="division date-pick-holder d-none justify-content-start align-items-center">
            <label
              htmlFor="date-pick-input"
              className="date-pick-label d-flex align-items-center"
            >
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.4062 1.79688H18.2383V0.898438C18.2383 0.40223 17.8361 0 17.3398 0C16.8436 0 16.4414 0.40223 16.4414 0.898438V1.79688H12.3535V0.898438C12.3535 0.40223 11.9513 0 11.4551 0C10.9589 0 10.5566 0.40223 10.5566 0.898438V1.79688H6.51367V0.898438C6.51367 0.40223 6.11144 0 5.61523 0C5.11903 0 4.7168 0.40223 4.7168 0.898438V1.79688H3.59375C1.61216 1.79688 0 3.40903 0 5.39062V19.4062C0 21.3878 1.61216 23 3.59375 23H10.4668C10.963 23 11.3652 22.5978 11.3652 22.1016C11.3652 21.6054 10.963 21.2031 10.4668 21.2031H3.59375C2.60295 21.2031 1.79688 20.397 1.79688 19.4062V5.39062C1.79688 4.39983 2.60295 3.59375 3.59375 3.59375H4.7168V4.49219C4.7168 4.98839 5.11903 5.39062 5.61523 5.39062C6.11144 5.39062 6.51367 4.98839 6.51367 4.49219V3.59375H10.5566V4.49219C10.5566 4.98839 10.9589 5.39062 11.4551 5.39062C11.9513 5.39062 12.3535 4.98839 12.3535 4.49219V3.59375H16.4414V4.49219C16.4414 4.98839 16.8436 5.39062 17.3398 5.39062C17.8361 5.39062 18.2383 4.98839 18.2383 4.49219V3.59375H19.4062C20.397 3.59375 21.2031 4.39983 21.2031 5.39062V10.5117C21.2031 11.0079 21.6054 11.4102 22.1016 11.4102C22.5978 11.4102 23 11.0079 23 10.5117V5.39062C23 3.40903 21.3878 1.79688 19.4062 1.79688ZM17.3398 10.332C17.836 10.332 18.2383 9.92979 18.2383 9.43359C18.2383 8.9374 17.836 8.53516 17.3398 8.53516C16.8437 8.53516 16.4414 8.9374 16.4414 9.43359C16.4414 9.92979 16.8437 10.332 17.3398 10.332ZM17.5645 12.1289C14.5673 12.1289 12.1289 14.5673 12.1289 17.5645C12.1289 20.5616 14.5673 23 17.5645 23C20.5616 23 23 20.5616 23 17.5645C23 14.5673 20.5616 12.1289 17.5645 12.1289ZM17.5645 21.2031C15.5581 21.2031 13.9258 19.5708 13.9258 17.5645C13.9258 15.5581 15.5581 13.9258 17.5645 13.9258C19.5708 13.9258 21.2031 15.5581 21.2031 17.5645C21.2031 19.5708 19.5708 21.2031 17.5645 21.2031ZM18.8672 16.666H18.4629V15.7227C18.4629 15.2264 18.0607 14.8242 17.5645 14.8242C17.0682 14.8242 16.666 15.2264 16.666 15.7227V17.5645C16.666 18.0607 17.0682 18.4629 17.5645 18.4629H18.8672C19.3634 18.4629 19.7656 18.0607 19.7656 17.5645C19.7656 17.0682 19.3634 16.666 18.8672 16.666ZM14.3301 9.43359C14.3301 9.92979 13.9278 10.332 13.4316 10.332C12.9354 10.332 12.5332 9.92979 12.5332 9.43359C12.5332 8.9374 12.9354 8.53516 13.4316 8.53516C13.9278 8.53516 14.3301 8.9374 14.3301 9.43359ZM9.52344 14.2402C10.0196 14.2402 10.4219 13.838 10.4219 13.3418C10.4219 12.8456 10.0196 12.4434 9.52344 12.4434C9.02724 12.4434 8.625 12.8456 8.625 13.3418C8.625 13.838 9.02724 14.2402 9.52344 14.2402ZM6.51367 9.43359C6.51367 9.92979 6.11143 10.332 5.61523 10.332C5.11904 10.332 4.7168 9.92979 4.7168 9.43359C4.7168 8.9374 5.11904 8.53516 5.61523 8.53516C6.11143 8.53516 6.51367 8.9374 6.51367 9.43359ZM5.61523 14.2402C6.11143 14.2402 6.51367 13.838 6.51367 13.3418C6.51367 12.8456 6.11143 12.4434 5.61523 12.4434C5.11904 12.4434 4.7168 12.8456 4.7168 13.3418C4.7168 13.838 5.11904 14.2402 5.61523 14.2402ZM6.51367 17.25C6.51367 17.7462 6.11143 18.1484 5.61523 18.1484C5.11904 18.1484 4.7168 17.7462 4.7168 17.25C4.7168 16.7538 5.11904 16.3516 5.61523 16.3516C6.11143 16.3516 6.51367 16.7538 6.51367 17.25ZM9.52344 18.1484C10.0196 18.1484 10.4219 17.7462 10.4219 17.25C10.4219 16.7538 10.0196 16.3516 9.52344 16.3516C9.02724 16.3516 8.625 16.7538 8.625 17.25C8.625 17.7462 9.02724 18.1484 9.52344 18.1484ZM10.4219 9.43359C10.4219 9.92979 10.0196 10.332 9.52344 10.332C9.02724 10.332 8.625 9.92979 8.625 9.43359C8.625 8.9374 9.02724 8.53516 9.52344 8.53516C10.0196 8.53516 10.4219 8.9374 10.4219 9.43359Z"
                  fill="#8E8E8E"
                />
              </svg>
              <span className="text">
                {this.props.translate("home.banner.date_range")}
              </span>
              <svg
                width="11"
                height="8"
                viewBox="0 0 11 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5 1.5L5.5 6.5L1.5 1.5"
                  stroke="#8E8E8E"
                  strokeWidth="1.35"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              type="checkbox"
              className="date-pick-input"
              id="date-pick-input"
            />
          </div>
          <div className="division person-count-holder d-none justify-content-start align-items-center">
            <label
              htmlFor="person-count-input"
              className="person-count-label d-flex align-items-center"
            >
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.2617 12.1272C16.8883 12.6885 18.3792 13.6157 19.6318 14.8682C21.8038 17.0403 23 19.9282 23 23H21.2031C21.2031 17.6497 16.8503 13.2969 11.5 13.2969C6.14967 13.2969 1.79688 17.6497 1.79688 23H0C0 19.9282 1.19622 17.0403 3.36829 14.8682C4.62084 13.6157 6.11171 12.6885 7.73833 12.1272C5.99613 10.9273 4.85156 8.91915 4.85156 6.64844C4.85156 2.9825 7.83406 0 11.5 0C15.1659 0 18.1484 2.9825 18.1484 6.64844C18.1484 8.91915 17.0039 10.9273 15.2617 12.1272ZM6.64844 6.64844C6.64844 9.32363 8.82486 11.5 11.5 11.5C14.1751 11.5 16.3516 9.32363 16.3516 6.64844C16.3516 3.97325 14.1751 1.79688 11.5 1.79688C8.82486 1.79688 6.64844 3.97325 6.64844 6.64844Z"
                  fill="#8E8E8E"
                />
              </svg>
              <span className="text">
                {this.props.translate("home.banner.persons")}
              </span>
              <svg
                width="11"
                height="8"
                viewBox="0 0 11 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5 1.5L5.5 6.5L1.5 1.5"
                  stroke="#8E8E8E"
                  strokeWidth="1.35"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              type="checkbox"
              className="person-count-input"
              id="person-count-input"
            />
          </div>
          {this.state.keyword ? (
            <button
              className="remove-keyword-button position-absolute"
              onClick={() => this.setState({ keyword: "" })}
              type="button"
            >
              <svg
                width="27"
                height="26"
                viewBox="0 0 27 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.2"
                  d="M13.1605 0C5.91368 0 0 5.84156 0 13C0 20.1584 5.91368 26 13.1605 26C20.4073 26 26.321 20.1584 26.321 13C26.321 5.84156 20.4073 0 13.1605 0Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.8015 8.44802C17.538 8.18445 17.1106 8.18445 16.8471 8.44802L13.1993 12.0958L9.49481 8.39136C9.23446 8.13101 8.81235 8.13101 8.552 8.39136C8.29165 8.65171 8.29165 9.07382 8.552 9.33417L12.2565 13.0386L8.60914 16.686C8.34558 16.9495 8.34558 17.3768 8.60914 17.6404C8.87271 17.904 9.30003 17.904 9.56359 17.6404L13.2109 13.9931L16.9151 17.6972C17.1754 17.9576 17.5975 17.9576 17.8579 17.6972C18.1182 17.4369 18.1182 17.0148 17.8579 16.7544L14.1537 13.0503L17.8015 9.40247C18.0651 9.1389 18.0651 8.71158 17.8015 8.44802Z"
                  fill="white"
                />
              </svg>
            </button>
          ) : (
            ""
          )}
          <BLButton
            type="sec"
            additionalClasses="send-button flex-shrink-0"
            action="submit"
            disabled={this.state.showQueryInfo || !this.state.keyword}
          >
            {this.props.translate("global.explore")}
          </BLButton>
          <CSSTransition
            in={Boolean(this.state.suggestions.length)}
            timeout={300}
            unmountOnExit
          >
            <BLSearchSuggestions
              translate={this.props.translate}
              lang={this.props.lang}
              suggestions={this.state.suggestions}
            />
          </CSSTransition>
        </form>
      </div>
    );
  }
}

export default withRouter(Search);
